module.exports = __webpack_public_path__ + "static/media/about-image.4424eb02.png";